(() => {
  const select = (root, selector) => Array.from(root.querySelectorAll(selector));

  select(document, '[data-mv-product-carousel]').forEach((root) => {
    const slides = select(root, '[data-mv-slide]');
    const dots = select(root, '[data-mv-dot]');
    const count = root.querySelector('[data-mv-count]');
    if (!slides.length) return;
    let index = 0;
    let startX = null;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, position) => { slide.hidden = position !== index; });
      dots.forEach((dot, position) => {
        if (position === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    };

    root.querySelector('[data-mv-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-mv-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.mvDot))));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    root.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      root.setPointerCapture?.(event.pointerId);
    });
    root.addEventListener('pointerup', (event) => {
      if (startX === null) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      root.releasePointerCapture?.(event.pointerId);
      startX = null;
    });
    root.addEventListener('pointercancel', () => { startX = null; });
  });

  select(document, '[data-mv-menu]').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      select(document, '[data-mv-menu]').forEach((other) => {
        if (other !== menu) other.open = false;
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    select(document, '[data-mv-menu][open]').forEach((menu) => { menu.open = false; });
  });
})();
